export const SUPER_ADMIN_TENANTS = '/super-admin/tenants';
export const SUPER_ADMIN_TENANT_BY_ID = '/super-admin/tenants/:tenantId';
export const SUPER_ADMIN_TENANT_STATUS =
  '/super-admin/tenants/:tenantId/status';
